"use client";

import React from "react";
import { Grid } from "@repo/ui";
import Section from "../components/Section";
import CategoryCard from "../components/CategoryCard";
import { hasData } from "@/lib/helpers";
import { useParams } from "next/navigation";

type TopCategoriesProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
    buttonText: string;
    buttonAction: string;
    topCategories: Category[];
  };
};

type Category = {
  id: number;
  name: string;
  slug: string;
  icon?: string;
  totalCourse: number;
  courses: { name: string }[];
};

const TopCategories = ({ data, sectionInfo }: TopCategoriesProps) => {
  const { country } = useParams<{ country: string }>();

  if (!hasData(data)) return null;

  return (
    <Section
      title={data.heading}
      actionLabel={data.buttonText}
      path={`${country ? `/${country}/${data?.buttonAction}` : data?.buttonAction}`}
      id={sectionInfo.sectionId}
      className={sectionInfo.sectionClass}
    >
      <Grid container spacing={2}>
        {data?.topCategories.map((category) => (
          <Grid item lg={3} md={4} sm={6} xs={12} key={category.id}>
            <CategoryCard
              title={category.name}
              slug={category.slug}
              totalCourses={category.totalCourse}
              courses={category.courses}
              className="hover:shadow-xl transition-all shadow-primary-light/10"
            />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default TopCategories;
